import React, { useCallback } from "react";

import { Button } from "../../../../Shared/Buttons/Button";
import { dmnIdentity } from "../../../../../utils/dmnIdentity";
import { getEnvironmentProps } from "../../../../../utils/environment";
import dayjs from "dayjs";
import { useDiaryContext } from "../../../../../hooks/useDiaryContext";
import { document } from "@workspace/mobile";
import {
  errorHandler,
  apiFetchNotOkHandler
} from "../../../../../APIs/errorHandler";
/**
 * Download Guest List Props
 */
type DownloadGuestListProps = {
  onClose?: () => void;
  onBack?: () => void;
};

/**
 * Download/Print Modal
 *
 * @param param0
 * @returns
 */
export const DownloadGuestListContent = ({
  onBack,
  onClose
}: DownloadGuestListProps) => {
  const { venueConfig, date } = useDiaryContext();
  const [fileType] = React.useState<string>("pdf");

  const handleBack = () => {
    onBack?.();
  };

  const handleDownload = useCallback(async () => {
    const token = await dmnIdentity.getAccessToken();
    const environmentVars = getEnvironmentProps(token);
    const isPDF = fileType === "csv";

    const url = new URL(
      `${environmentVars?.COLLINS_API_BASE_URL}/reports/guest-list`
    );
    url.searchParams.set("date", dayjs(date).format("YYYY-MM-DD"));
    url.searchParams.set("format", `guest-list-${fileType}`);
    url.searchParams.set("output", fileType);
    url.searchParams.set("status", "in_progress,complete");
    url.searchParams.set("venue_id", venueConfig?._id ?? "");

    try {
      const request = await fetch(url, {
        headers: {
          authorization: `Bearer ${token}`
        },
        method: "GET"
      });

      if (!request.ok) {
        apiFetchNotOkHandler(request, "Error downloading guest list");
        return;
      }

      const arrBuffer = await request.arrayBuffer();
      const file = new Blob([arrBuffer], {
        type: isPDF ? "application/pdf" : "text/csv"
      });

      // Read out the data into a file reader
      const fileReader = new FileReader();

      fileReader.onloadend = async () => {
        // Parse out the result to get the document data.
        const result = fileReader.result as string;
        const [, mimeType, , data] = result.split(/[:;,]+/);
        const fileName = `guest-list.${isPDF ? "pdf" : "csv"}}`;
        document.open({ mimeType, data, fileName });
      };

      fileReader.readAsDataURL(file);
    } catch (error) {
      errorHandler(error, "Error downloading guest list");
      return;
    }

    onClose?.();
  }, [fileType]);

  return (
    <div className="DownloadFileCotainer flex flex-col flex-1">
      <div className="DownloadFileContent flex-1 flex flex-col">
        <p>Provides a list of customer sorted by time in Excel (CSV) format.</p>
        {/* 
                        The API is broken... only the CSV version is downloading correctly
                    <p>
                        <strong>File type</strong>
                    </p> */}
        {/*  
                    <div>
                    <div className="InlineTabsWrapper InlineTabsWrapperStart">
                        <ToggleButton
                            text1="PDF"
                            text2="Excel/CSV"
                            selected={fileType === "pdf"}
                            onClick={(e) => {
                                fileType === "pdf" ? setFileType("csv") : setFileType("pdf");
                            }}
                        />
                    </div>
                </div>*/}
      </div>
      <div className="DownloadFileFooter flex-none flex flex-row gap-2.5">
        <Button className="DownloadFileFooterButton" onClick={handleBack}>
          Back
        </Button>
        <Button
          className="DownloadFileFooterButton"
          onClick={handleDownload}
          type="primary"
        >
          Download Guest List
        </Button>
      </div>
    </div>
  );
};
